import React, { FC } from 'react'

import { AnalyticsEventAddToCart } from '../../../../lib/analytics/state'
import type { Product, UseProducts } from '../../../../lib/products'
import ProductListCard from '../ProductListCard'
import * as Styled from './styled'

export interface ProductListProps {
  className?: string
  paginationState: UseProducts['listing']['state']['pagination']
  productsPagination: UseProducts['pagination']
  products?: Product[] | null
  analyticsEventAppContext?: AnalyticsEventAddToCart['app_context']
}

const ProductList: FC<ProductListProps> = ({
  className,
  paginationState,
  productsPagination,
  products,
  analyticsEventAppContext,
}) => {
  const { data, actions } = productsPagination
  const { size: pageSize } = paginationState

  return (
    <Styled.ProductList className={className}>
      {products?.map((product, index) => {
        const page = data.firstPage + Math.floor(index / pageSize)
        const isLastOfPage = (index + 1) % pageSize === 0 || index + 1 === products.length
        return (
          product && (
            <ProductListCard
              key={product.id}
              product={product}
              page={page}
              effectCallback={isLastOfPage ? actions.lastOfPageEffectCallback : null}
              analyticsEventAppContext={analyticsEventAppContext}
            />
          )
        )
      })}
    </Styled.ProductList>
  )
}

export default ProductList
